// ============================================================================
//  parallax.js — scroll parallax on section imagery (GSAP + ScrollTrigger)
//
//  Each [data-parallax] image drifts vertically as its section scrolls through
//  the viewport, giving depth. The images are oversized in CSS (see the
//  `[data-parallax]` rules) so the drift never exposes an edge.
//
//   - reducedMotion → no-op (images stay put).
//   - GSAP is imported lazily to keep it out of the critical path.
// ============================================================================

export async function initParallax({ reducedMotion = false } = {}) {
  const els = document.querySelectorAll('[data-parallax]');
  if (!els.length || reducedMotion) return;

  const { gsap } = await import('gsap');
  const { ScrollTrigger } = await import('gsap/ScrollTrigger');
  gsap.registerPlugin(ScrollTrigger);

  els.forEach((el) => {
    const speed = parseFloat(el.dataset.parallax) || 10; // % of travel
    const scope = el.closest('.media, .hero, .site-footer, .founder__photo') || el.parentElement;

    gsap.fromTo(
      el,
      { yPercent: -speed },
      {
        yPercent: speed,
        ease: 'none',
        scrollTrigger: {
          trigger: scope,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      }
    );
  });

  // Recalculate once fonts/images settle.
  window.addEventListener('load', () => ScrollTrigger.refresh());
}
